import { resolveLocalRequest } from './resolver';

function createLocalApiInstance(): any {
  const instance: any = function (url: string, config?: any) {
    return resolveLocalRequest('get', url, config || {});
  };

  instance.get = function (url: string, config?: any) {
    return resolveLocalRequest('get', url, config || {});
  };

  instance.post = function (url: string, data?: any, config?: any) {
    return resolveLocalRequest('post', url, { ...(config || {}), data: data || {} });
  };

  instance.put = function (url: string, data?: any, config?: any) {
    return resolveLocalRequest('put', url, { ...(config || {}), data: data || {} });
  };

  instance.delete = function (url: string, config?: any) {
    return resolveLocalRequest('delete', url, config || {});
  };

  instance.interceptors = {
    request: { use: function () {} },
    response: { use: function () {} }
  };

  return instance;
}

export default createLocalApiInstance;
